const convertFullMembershipNumberTo8 = (membership16: string) => {
  return membership16.substr(6, 8);
};

export const getMembershipNumber8 = (membershipNumber: string): string => {
  if (typeof membershipNumber !== 'string') {
    return '';
  }

  if (membershipNumber.length === 8) {
    return membershipNumber;
  }

  if (membershipNumber.length === 16) {
    return convertFullMembershipNumberTo8(membershipNumber);
  }

  return '';
};

export const getClubCodeFromMembershipNumber = (membershipNumber: string) =>
  membershipNumber && membershipNumber.length === 16 ? membershipNumber.substr(3, 3) : '';
